import {
  ISurveyBlockModel,
  IEvaluationBlockModel,
  IMeetingBlockModel,
  ISessionBlockModel,
  IBlockInstanceModelSimple,
} from 'models/block.model'
import { IRichTextBlockModel } from 'models/blockRichText.model'
import api from '../..'

export const createBlockSurveyInstance = (data: ISurveyBlockModel) => {
  return api.post('administration/block_surveys', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createRichTextInstance = (data: IRichTextBlockModel) => {
  return api.post('administration/block_rich_texts', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}

export const createTaskInstance = (data: IRichTextBlockModel) => {
  return api.post('administration/block_tasks', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createMultimediaInstance = (data: IRichTextBlockModel) => {
  return api.post('administration/block_multimedias', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createScormInstance = (data: IRichTextBlockModel) => {
  return api.post('administration/block_scorm', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createMeetingInstance = (data: IMeetingBlockModel) => {
  return api.post('administration/block_meeting', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createSessionInstance = (data: ISessionBlockModel) => {
  return api.post('administration/block_session', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
export const createEvaluationInstance = (data: IEvaluationBlockModel) => {
  return api.post('administration/block_evaluations', data).then(
    ({
      data: {
        data: {
          attributes: { blockInstanceable },
        },
      },
    }) => {
      const data: IBlockInstanceModelSimple = {
        id: blockInstanceable.blockInstanceableId,
        instanceId: blockInstanceable.id,
        name: blockInstanceable.name,
        description: blockInstanceable.description,
        mandatory: blockInstanceable.mandatory,
        lessonId: blockInstanceable.lessonId,
        order: blockInstanceable.order,
      }
      return data
    }
  )
}
